import React from 'react';
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'stores/auth';

const Stepper = (props) => {
    const [cartCount] = useGlobal('cartCount');
    const { t } = useTranslation(['stepper']);
    const auth = useAuth();
    const { activeStep } = props;
    const IconCheck = () => <i class="fa fa-check" aria-hidden="true"></i>;
    const isContactDone = auth.user || (cartCount > 0);
    const getActiveStepNr = (step) => {
        switch (step) {
            case 'bookingdata': return 1;
            case 'options': return 2;
            case 'contact': return 3;
            case 'overview': return 4;
            case 'payment': return 5;
            case 'confirmation': return 6;
            default: return 0;
        }
    }
    const activeStepNr = getActiveStepNr(activeStep);

    return (
        <section className="wizardsteps-container">
            <div className="wrapper">
                <div className="wizardsteps-steps">
                    <div className={"step step-bookingdata" + `${activeStep === 'bookingdata' ? ' active' : (activeStepNr > 1 ? ' done' : '')}`}>
                        <div className="step-icon">{activeStepNr > 1 ? <IconCheck /> : 1}</div>
                        <div className="step-label">{t("bookingdata")}</div>
                    </div>
                    <div className={"step step-options" + `${activeStep === 'options' ? ' active' : (activeStepNr > 2 ? ' done' : '')}`}>
                        <div className="step-icon">{activeStepNr > 2 ? <IconCheck /> : 2}</div>
                        <div className="step-label">{t("options")}</div>
                    </div>
                    {<div className={"step step-contact" + `${activeStep === 'contact' ? ' active' : ((activeStepNr > 3 || isContactDone) ? ' done' : '')}`}>
                        <div className="step-icon">{(activeStepNr > 3 || isContactDone) ? <IconCheck /> : 3}</div>
                        <div className="step-label">{t("contact")}</div>
                    </div>}
                    <div className={"step step-overview" + `${activeStep === 'overview' ? ' active' : (activeStepNr > 4 ? ' done' : '')}`}>
                        <div className="step-icon">{activeStepNr > 4 ? <IconCheck /> : 4}</div>
                        <div className="step-label">{t("overview")}</div>
                    </div>
                    <div className={"step step-payment" + `${activeStep === 'payment' ? ' active' : (activeStepNr > 5 ? ' done' : '')}`}>
                        <div className="step-icon">{activeStepNr > 5 ? <IconCheck /> : 5}</div>
                        <div className="step-label">{t("payment")}</div>
                    </div>
                </div>
            </div>
            <div className="wizardsteps-bar">
                <div className="step-bar" style={{ width: `${(activeStepNr - 1) / 5 * 100}%` }}></div>
            </div>
        </section>
    )
}

export default Stepper;